import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import _template from 'properties/style/background-button.ejs';
import { pickerCfg } from 'pickerCfg.js';

class StyleButtonBackgroundView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        return this;
    }

    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //.$('input[type=color]').spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

}

export default StyleButtonBackgroundView;
